// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/style/result.css";
import VueI18n from "vue-i18n";
// 从语言包文件中导入语言包对象
import locale from "element-ui/lib/locale";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import enLocale from "element-ui/lib/locale/lang/en";
import "vue2-animate/dist/vue2-animate.min.css"

import VueLazyload from 'vue-lazyload'
Vue.config.productionTip = false;
Vue.prototype.IPCONFIG = IPCONFIG
Vue.use(VueI18n);
Vue.use(VueLazyload);
Vue.use(ElementUI);
const i18n = new VueI18n({
  // 语言标识,默认汉语,先去localStorage查找，如果存在并有效，localStorage值即为默认语言类型；否则默认为中文简体
  // localStorage.getItem("DefaultLanguage") == null ? 'zh-CN' :
  locale:
  localStorage.getItem("DefaultLanguage") == null
      ? "zh-CN"
      : localStorage.getItem("DefaultLanguage"),
  messages: {
    "zh-CN": Object.assign(require("../static/lang/zh-CN.js"), zhLocale),
    "en-US": Object.assign(require("../static/lang/en.js"), enLocale)
  }
});
locale.i18n((key, value) => i18n.t(key, value)); //为了之后将element-ui组件本地化
Vue.prototype.$addStorageEvent = function(key, data) {
  // 创建一个StorageEvent事件
  var newStorageEvent = document.createEvent("StorageEvent");
  const storage = {
    setItem: function(k, val) {
      localStorage.setItem(k, val);
      // 初始化创建的事件
      newStorageEvent.initStorageEvent(
        "setItem",
        false,
        false,
        k,
        null,
        val,
        null,
        null
      );
      // 派发对象
      window.dispatchEvent(newStorageEvent);
    }
  };
  return storage.setItem(key, data);
};
Vue.prototype.$addStorageEvent2 = function(key, data) {
  // 创建一个StorageEvent事件
  var newStorageEvent2 = document.createEvent("StorageEvent");
  const storage = {
    setItem: function(k, val) {
      sessionStorage.setItem(k, val);
      // 初始化创建的事件
      newStorageEvent2.initStorageEvent(
        "setItem",
        false,
        false,
        k,
        null,
        val,
        null,
        null
      );
      // 派发对象
      window.dispatchEvent(newStorageEvent2);
    }
  };
  return storage.setItem(key, data);
};
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js